import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

export const isNativePlatform = () => Capacitor.isNativePlatform();

export const isWebPlatform = () => !Capacitor.isNativePlatform();

/**
 * Open the given URL for OAuth.
 * - Native (iOS/Android): uses Capacitor Browser
 * - Web: navigates in the same tab
 *
 * IMPORTANT: On iOS, the caller must ensure any Browser listeners are
 * registered before invoking this to avoid leaks when the app is GC'ed.
 */
export async function openOAuthUrl(url: string): Promise<void> {
  if (isNativePlatform()) {
    await Browser.open({ url, presentationStyle: 'popover' });
    return;
  }

  window.location.href = url;
}

/**
 * Best-effort close of the in-app browser on native platforms.
 * Safe to call even if the browser is not currently open.
 */
export async function closeInAppBrowserIfOpen(): Promise<void> {
  if (!isNativePlatform()) return;
  try {
    await Browser.close();
  } catch {
    // Ignore – Browser may not be open or supported on this platform
  }
}

